module.exports = __webpack_public_path__ + "img/img-store-step1.5b94147b.svg";